import React from 'react'
import { number } from 'prop-types'
import styled from 'styled-components'

import { Button } from '../Button'
import { baseTiltifyUrl, getSubdomainUrl } from '../../utils'

const StyledDiv = styled.div`
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;

  text-align: center;
  font-size: 14px;
  background-color: ${({ theme }) => theme.danger};
  color: #ffffff;

  @media (max-width: 1400px) {
    flex-direction: column;
    padding: 1rem 3rem;
  }
`

const StyledHeading = styled.h3`
  font-weight: bold;
`

export const ImpersonationBanner = ({ id }) => {
  return (
    <StyledDiv>
      <StyledHeading>You are in impersonation mode</StyledHeading>
      <Button
        as='a'
        size='small'
        intent='primary'
        style={{ marginLeft: '15px' }}
        href={getSubdomainUrl(
          `${baseTiltifyUrl()}/impersonation/logout?causeUserId=${id}`,
          'admin'
        )}
      >
        Log Out
      </Button>
    </StyledDiv>
  )
}

ImpersonationBanner.propTypes = {
  id: number,
}
